import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const InfoRound = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg viewBox="0 0 16 16" ref={ref} {...props}>
          <path
            d="M8 5.5V5.6M8 7.5V10.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
            stroke="currentColor"
            strokeLinecap="square"
          />
        </svg>
      </Icon>
    );
  },
);

InfoRound.displayName = "InfoRound";
